module.exports = __webpack_public_path__ + "img/news_brown.04004ef6.svg";